import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faChartPie, 
    faBuilding, 
    faStore, 
    faList, 
    faUsers, 
    faTv, 
    faExternalLinkAlt,
    faChevronLeft,
    faChevronRight,
    faCreditCard,
    faPuzzlePiece,
    faBolt,
    faShieldAlt,
    faDatabase,
    faGem,
    faRocket,
    faBriefcase,
    faDesktop
} from '@fortawesome/free-solid-svg-icons';
import TuFilaLogo from '../resources/TuFilaLogo';

const iconMap = {
    faChartPie, faBuilding, faStore, faList, faUsers, faTv, faExternalLinkAlt,
    faCreditCard, faPuzzlePiece, faBolt, faShieldAlt, faDatabase, faGem, faRocket, faBriefcase, faDesktop
};

/**
 * AdminSidebar - Premium collapsible navigation with grouped categories
 */
const AdminSidebar = ({ activeTab, onTabChange, isCollapsed, toggleCollapse, menuGroups = [] }) => {
    
    // Default fallback if no dynamic menu is provided
    const defaultMenu = [
        {
            title: 'Configuración',
            items: [
                { id: 'tipos', label: 'Sectores / Tipos', icon: faList },
                { id: 'boxes', label: 'Boxes / Puestos', icon: faDesktop },
                { id: 'usuarios', label: 'Personal', icon: faUsers },
            ]
        }
    ];

    const finalMenu = menuGroups.length > 0 ? menuGroups : defaultMenu;

    return (
        <motion.div 
            className="admin-sidebar"
            initial={false}
            animate={{ width: isCollapsed ? 80 : 280 }}
            transition={{ duration: 0.3, ease: [0.23, 1, 0.32, 1] }}
        >
            <div className={`sidebar-header d-flex flex-column align-items-center justify-content-center position-relative ${isCollapsed ? 'py-4' : 'py-5'}`}>
                <motion.div 
                    initial={false}
                    animate={{ scale: isCollapsed ? 0.4 : 1, y: isCollapsed ? 0 : 0 }}
                    className="d-flex flex-column align-items-center"
                >
                    <TuFilaLogo size={isCollapsed ? 80 : 140} />
                    {!isCollapsed && (
                        <motion.small 
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="mt-2 text-uppercase font-weight-bold opacity-50"
                            style={{ fontSize: '0.65rem', letterSpacing: '2px', color: 'var(--turnero-text-main)' }}
                        >
                            TuFila Inteligente
                        </motion.small>
                    )}
                </motion.div>
                
                <button 
                    className="btn-collapse" 
                    onClick={toggleCollapse}
                    title={isCollapsed ? 'Expandir' : 'Colapsar'}
                >
                    <FontAwesomeIcon icon={isCollapsed ? faChevronRight : faChevronLeft} />
                </button>
            </div>

            <div className="sidebar-nav custom-scrollbar" style={{ overflowY: 'auto', flex: 1 }}>
                {finalMenu.map((group, gIdx) => (
                    <div key={gIdx} className="mb-4">
                        {!isCollapsed && (
                            <div className="sidebar-group-label">
                                {group.title || group.GroupLabel}
                            </div>
                        )}
                        <div className="d-flex flex-column gap-1">
                            {group.items.map((item) => (
                                <div 
                                    key={item.id}
                                    className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
                                    onClick={() => onTabChange(item.id)}
                                    >
                                    <FontAwesomeIcon icon={typeof item.icon === 'string' ? (iconMap[item.icon] || faChartPie) : (item.icon || faChartPie)} className="nav-icon" />
                                    {!isCollapsed && (
                                        <motion.span 
                                            initial={{ opacity: 0, x: -10 }} 
                                            animate={{ opacity: 1, x: 0 }}
                                        >
                                            {item.itemId ? `${item.itemId} - ` : ''}{item.label}
                                        </motion.span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div className="sidebar-footer">
                {!isCollapsed && (
                    <div className="d-flex flex-column">
                        <small className="tiny text-uppercase font-weight-bold opacity-30">OctoCore Engine</small>
                        <small className="tiny font-weight-bold text-primary">v2.1 Premium</small>
                    </div>
                )}
                {isCollapsed && <small className="tiny font-weight-bold text-primary">v2.1</small>}
            </div>
        </motion.div>
    );
};

export default AdminSidebar;
